import { render, staticRenderFns } from "./RecruiterDashboard.vue?vue&type=template&id=9c54fd46&scoped=true"
import script from "./RecruiterDashboard.vue?vue&type=script&lang=js"
export * from "./RecruiterDashboard.vue?vue&type=script&lang=js"
import style0 from "./RecruiterDashboard.vue?vue&type=style&index=0&id=9c54fd46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c54fd46",
  null
  
)

export default component.exports